import { QueryClient } from '@tanstack/react-query';
import { configureEntryOperationsQueryClient } from '@/Config/api/entryOperationsQueryClient.config';

export const entryQueryClientConfig = new QueryClient();
configureEntryOperationsQueryClient(entryQueryClientConfig);
